<template>
  <custom-callout
    class-main="mt-3 mb-n1"
    :border-color="statusColor"
    :has-toggle="false"
    :opened="isExpanded"
  >
    <div class="row py-1 mr-md-0 ">
      <div class="col-12 col-md-2 text-center border-right border-right-2">
        <div class="font-weight-bold">
          <span
            :class="
              `mb-1 font-light font-16 py-2 mt-2 w-70 mx-auto badge badge-pill badge-${statusColor} d-none d-md-block`
            "
          >
            {{ data.statusName | empty }}
          </span>
        </div>
      </div>
      <div class="col-12 col-md pr-0">
        <div class="pl-4">
          <div class="row mb-3">
            <div class="col-12 col-md-4">
              <span class="data-title d-block">Nombre:</span>
              <span class="font-14 color-black">
                {{ data.studentFullName | empty }}
              </span>
            </div>
            <div class="col-12 col-md-2">
              <span class="data-title d-block">SIE:</span>
              <span class="font-14 color-black">
                {{ data.studentSieId | empty }}
              </span>
            </div>
            <div class="col-12 col-md">
              <span class="data-title d-block">Registro:</span>
              <span class="font-14 color-black">
                {{ data.registerNumber | empty }}
              </span>
            </div>
            <div class="col-12 col-md">
              <span class="data-title d-block">Grado:</span>
              <span class="font-14 color-black">
                {{ data.grade | empty }}
              </span>
            </div>
            <div class="col-12 col-md mt-1">
              <div class="dropdown">
                <action-button
                  class="btn btn-dropdown-actions dropdown-toggle pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </action-button>
                <div class="dropdown-menu dropdown-menu-right py-0">
                  <action-button
                    type="button"
                    class="dropdown-item cursor-pointer text-left border-bottom"
                    i="fas fa-clock fa-fw text-green mr-2"
                    text="Historial"
                    v-if="hasHistory"
                    @click="showHistory()"
                  />
                  <action-button
                    type="button"
                    class="dropdown-item cursor-pointer text-left border-bottom"
                    i="fas fa-comment fa-fw text-green mr-2"
                    @click="() => onShowAddCommentPanel()"
                    text="Añadir Comentario"
                  />
                  <action-button
                    type="button"
                    class="dropdown-item cursor-pointer text-left border-bottom"
                    i="fas fa-file-import fa-fw text-green mr-2"
                    text="Entrar"
                    v-if="canShowEnterOption && !isEdenSubmitted"
                    @click="onEnter"
                  />

                  <action-button
                    type="button"
                    class="dropdown-item cursor-pointer text-left border-bottom"
                    i="fas fa-eye fa-fw text-green mr-2"
                    text="Ver"
                    v-if="canShowShowOption"
                    @click="onEnter"
                  />
                  <action-button
                    type="button"
                    class="dropdown-item cursor-pointer text-left border-bottom"
                    i="fas fa-reply-all fa-fw text-green mr-2"
                    text="Devolver"
                    v-if="canShowReturnOption && !isEdenSubmitted"
                    @click="showReturn"
                  />
                  <action-button
                    type="button"
                    class="dropdown-item cursor-pointer text-left border-bottom"
                    i="fas fa-file-alt text-green mr-2"
                    text="Comentario"
                    v-if="hasSieId"
                    @click="redirectToComments"
                  />
                  <action-button
                    type="button"
                    class="dropdown-item cursor-pointer text-left"
                    i="fas fa-times-circle fa-fw text-red mr-2"
                    text="Cancelar"
                    v-if="canShowCancelOption && !isEdenSubmitted"
                    @click="showCancel"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md">
              <span class="data-title d-block">Impedimento:</span>
              <span class="font-14 color-black">
                {{ data.impedimentName | empty }}
              </span>
            </div>
            <div class="col-12 col-md">
              <span class="data-title d-block">Municipio / Escuela:</span>
              <span class="font-14 color-black">
                {{ data.municipalitySchool | empty }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #edition>
      <add-comment-form
        v-if="showAddCommentPanel"
        @cancel="onCancelAddCommentHandler"
        @submit="onSaveAddCommentHandler"
      />
      <div v-else class="bg-gray p-2">
        <status-timeline
          v-if="showHistoryTab"
          :history="data.statusLog"
          @close="showHistory()"
        />
        <change-status
          v-if="showReturnTab"
          :text="'devolver'"
          :id="data.id"
          :status-id="getReturnStatus"
          @close="showReturn"
          @saved="onChangeStatusSaved"
        />
        <change-status
          v-if="showCancelTab"
          :text="'cancelar'"
          :id="data.id"
          :status-id="getCancelStatus"
          @close="showCancel"
          @saved="onChangeStatusSaved"
        />
      </div>
    </template>
  </custom-callout>
</template>

<script>
import CustomCallout from "custom-callout";
import ActionButton from "ActionButton";
import {
  getVisualImpairmentStatusColor,
  visualImpairmentStatuses
} from "@/utils/constants/student/visualImpairmentsStatus";
import StatusTimeline from "./StatusTimeline";
import ChangeStatus from "./ChangeStatus";
import { AddCommentForm } from "@quisit/comments";
import studentService from "@/services/student.js";
import objectToFormData from "object-to-formdata";
import commentTypes from "@/utils/constants/comment/commentTypes";
import mixAlert from "@/mixin/alert.mixin";
import commentCategories from "@/utils/constants/comment/commentTypes";
import viewTypes from "@/utils/constants/comment/CodeViewTypes.js";
import store, { modulesName } from "@/store/index";

export default {
  name: "ResultRow",
  components: {
    CustomCallout,
    ActionButton,
    StatusTimeline,
    ChangeStatus,
    AddCommentForm
  },
  mixins: [mixAlert],
  data() {
    return {
      showHistoryTab: false,
      showReturnTab: false,
      showAddCommentPanel: false,
      isExpanded: false,
      showCancelTab: false
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  computed: {
    hasSieId() {
      return !!this.data.studentSieId;
    },
    statusColor() {
      return getVisualImpairmentStatusColor(this.data.statusId);
    },
    hasHistory() {
      return this.data.statusLog.length > 0;
    },
    isEdenSubmitted() {
      return this.data.isEdenSubmitted;
    },
    canShowReturnOption() {
      return (
        this.data.statusId == visualImpairmentStatuses.Submitted &&
        this.$store.getters.HasPermission(
          "student.studentvisualimpairments.return"
        )
      );
    },
    canShowCancelOption() {
      return (
        this.data.statusId != visualImpairmentStatuses.Cancelled &&
        this.$store.getters.HasPermission(
          "student.studentvisualimpairments.cancel"
        )
      );
    },
    canShowEnterOption() {
      const validStatus = [
        visualImpairmentStatuses.InProcess,
        visualImpairmentStatuses.New
      ];
      return validStatus.includes(this.data.statusId);
    },
    canShowShowOption() {
      const validStatus = [
        visualImpairmentStatuses.Submitted,
        visualImpairmentStatuses.Returned
      ];
      return validStatus.includes(this.data.statusId);
    },
    getReturnStatus() {
      return visualImpairmentStatuses.Returned;
    },
    getCancelStatus() {
      return visualImpairmentStatuses.Cancelled;
    }
  },
  methods: {
    async redirectToComments() {
      const hasDifferentStudentSelected = store.state.$_student.selectedStudent
        ? true &&
          store.state.$_student.selectedStudent.studentId.toString() !==
            this.data.studentSieId.toString()
        : false;
      let response;
      if (hasDifferentStudentSelected) {
        response = await this.ShowCancelModal(
          "Atención",
          "El sistema detectó que se cambió el estudiante, usted será redireccionado al menú principal. ¿Está seguro que desea continuar?",
          "Sí",
          "No"
        );
      }
      if (response || !hasDifferentStudentSelected) {
        this.$router.push({
          name: "studentAddComment",
          params: {
            commentDate: new Date(),
            studentSieId: this.data.studentSieId,
            categoryId:
              commentCategories.RegistroEstudiantesImpedimentosVisuales,
            codeViewTypeId: viewTypes.AnadirComentario
          }
        });
      } else {
        return false;
      }
    },
    onEnter() {
      this.$emit("enter", this.data);
    },
    showHistory() {
      this.showHistoryTab = !this.showHistoryTab;
      this.isExpanded = this.showHistoryTab;
    },
    showReturn() {
      this.showReturnTab = !this.showReturnTab;
      this.isExpanded = this.showReturnTab;
    },
    showCancel() {
      this.showCancelTab = !this.showCancelTab;
      this.isExpanded = this.showCancelTab;
    },
    onShowAddCommentPanel() {
      this.showAddCommentPanel = true;
      this.isExpanded = true;
    },
    onChangeStatusSaved() {
      this.showReturnTab = false;
      this.showCancelTab = false;
      this.isExpanded = false;
      this.$emit("saved");
    },
    async onCancelAddCommentHandler() {
      this.showAddCommentPanel = false;
      this.isExpanded = false;
    },
    async onSaveAddCommentHandler(payload) {
      try {
        let formData = objectToFormData(
          {
            studentSieId: this.data.studentSieId,
            categoryTypeId:
              commentTypes.RegistroEstudiantesImpedimentosVisuales,
            description: payload.comment
          },
          { indices: true }
        );

        if (payload.file) {
          formData.append("attachment", payload.file);
        }

        await studentService.saveComment(formData);

        this.ShowToast(
          "Completado",
          "Su información ha sido procesada exitosamente.",
          "success"
        );
        this.isExpanded = false;
        this.showAddCommentPanel = false;
      } catch (e) {
        this.ShowToast("", e.message || "error", "error");
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/variables/_colors.scss";
.border-right-2 {
  border-right: 2px solid #dee2e6 !important;
}
.badge-secondary-2 {
  background-color: map-get($colors, "secondary-2");
}
.badge-green-light {
  background-color: map-get($colors, "green-light");
}
.badge-yellow {
  background-color: map-get($colors, "yellow");
}
.badge-violet {
  background-color: map-get($colors, "violet");
}
.badge-brown {
  background-color: map-get($colors, "brown");
}
</style>
